exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade-enter-active[data-v-72b154b2],.fade-leave-active[data-v-72b154b2]{transition:opacity .5s}.fade-enter[data-v-72b154b2],.fade-leave-to[data-v-72b154b2]{opacity:0}#pdf_viewer[data-v-72b154b2]{width:100%;height:800px}.pdf-wrapper[data-v-72b154b2]{margin-bottom:150px}.pdf-wrapper .document-pdf[data-v-72b154b2]{width:550px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-72b154b2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/report/HistoryReport.vue
// module id = 1759
// module chunks = 0